var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Tooltip', {
    attrs: {
      "max-width": _vm.width,
      "placement": _vm.placement,
      "content": _vm.content,
      "transfer": true
    }
  }, [_c('div', {
    style: (("line-height: 32px;display: flex;align-items: center;color:" + _vm.color))
  }, [_vm._v("\n      " + _vm._s(_vm.name) + "\n    "), _c('Icon', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": _vm.icon,
      "size": _vm.size
    }
  })], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6b911839", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b911839","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PageTooltip.vue
// module id = zX3w
// module chunks = 142